<div *ngIf="!creatingModel">
  <label id="listbox-label" class="block text-sm font-medium leading-6 text-gray-900"></label>
  <div class="relative mt-2">
    <div class="relative w-full cursor-default rounded-md bg-white py-1.5 pl-3 pr-3 text-left text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:outline-none focus:ring-2 focus:ring-accent-lighter sm:text-sm sm:leading-6" >
      

      <div class="relative my-2 rounded-md shadow-sm">
        <div class="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
          
          <svg fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="h-5 w-5 text-gray-400">
            <path stroke-linecap="round" stroke-linejoin="round" d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z" />
          </svg>
          
        </div>
        <input [formControl]="searchControl" type="text" class="block border-0 w-full rounded-md py-1.5 pl-10 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-accent sm:text-sm sm:leading-6" placeholder="Search by name, phone, telephone or email...">
        
        <div (click)="toggleList()" class=" absolute inset-y-0 right-0 flex items-center pr-3">
          <svg fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="h-5 w-5 text-gray-400">
            <path stroke-linecap="round" stroke-linejoin="round" d="m19.5 8.25-7.5 7.5-7.5-7.5" />
          </svg>
        </div>

      </div>

    </div>



    <div id="list-wrap" *ngIf="listOpen" class="relative z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white pt-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm" tabindex="-1" role="listbox" aria-labelledby="listbox-label" aria-activedescendant="listbox-option-3">
      <ul class="pb-6">
        <li (click)="modelPicked(result)" *ngFor="let result of options" class="relative group cursor-pointer select-none py-2 pl-3 pr-9 text-gray-900 hover:bg-accent-light hover:text-white" id="listbox-option-0" role="option">
          <div class="flex">
            <div class="w-8 h-8 rounded-full mr-2 opacity-60 text-accent flex flex-col justify-center text-center text-xs group-hover:bg-white group-hover:text-accent group-hover:ring-accent" [ngStyle]="{ 'background-color': stringToHexColor(result) }">{{ getInitials(result) }}</div>
            <span class="truncate font-normal">{{ getResultDisplayname(result) }}</span>
            <span *ngIf="model === 'customer'" class="ml-2 truncate text-gray-500 group-hover:text-gray-100">{{ result.email }}</span>
          </div>
          <span *ngIf="result.id === (selectedModel && selectedModel.id)" class="absolute inset-y-0 right-0 flex items-center pr-4 text-accent group-hover:text-white">
            <svg class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
              <path fill-rule="evenodd" d="M16.704 4.153a.75.75 0 01.143 1.052l-8 10.5a.75.75 0 01-1.127.075l-4.5-4.5a.75.75 0 011.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 011.05-.143z" clip-rule="evenodd" />
            </svg>
          </span>
        </li>

        <li *ngIf="!options || options.length === 0" class="relative group select-none py-2 pl-3 pr-9 text-gray-900 " id="listbox-option-0" role="option">
          <div class="flex">
            
            
            <span *ngIf="model === 'rider'" class="ml-2 truncate text-gray-500 ">No riders found, please create a new one</span>
          </div>
          
        </li>

      </ul>
    
      <div id="new-customer" (click)="createNewCustomerClicked()" class="sticky bottom-0 w-full bg-white border-t border-t-gray-200 py-4 px-3 cursor-pointer">
        <div class="flex">
          <svg fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6 mr-2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M18 7.5v3m0 0v3m0-3h3m-3 0h-3m-2.25-4.125a3.375 3.375 0 1 1-6.75 0 3.375 3.375 0 0 1 6.75 0ZM3 19.235v-.11a6.375 6.375 0 0 1 12.75 0v.109A12.318 12.318 0 0 1 9.374 21c-2.331 0-4.512-.645-6.374-1.766Z" />
          </svg>
          <span class="truncate font-normal">Add new {{ model }}</span>
        </div>
      </div>
    </div>
    
  </div>
</div>

<div *ngIf="creatingModel && model === 'customer'" class="">
  <ubc-customer-edit-form (cleared)="modelCreateCancelled()" (customerCreated)="newModelCreated($event)"></ubc-customer-edit-form>
</div>

<div *ngIf="creatingModel && model === 'rider'" class="">
  <ubc-rider-edit-form (cleared)="modelCreateCancelled()" (riderCreated)="newModelCreated($event)"></ubc-rider-edit-form>
</div>


